
import React from 'react';
import { cn } from '@/lib/utils';

interface PageSectionProps {
  children: React.ReactNode;
  className?: string;
  dark?: boolean;
  containerClassName?: string;
  id?: string;
}

const PageSection = ({ 
  children, 
  className, 
  dark = false, 
  containerClassName,
  id
}: PageSectionProps) => {
  return (
    <section 
      id={id}
      className={cn(
        "py-20 px-6 md:px-10",
        dark && "bg-gray-900 text-white",
        className
      )}
    >
      <div className={cn("container mx-auto", containerClassName)}>
        {children}
      </div>
    </section>
  );
};

export default PageSection;
